import { Action, ActionType } from "@redux/actionTypes/ipdActionType";
import { Reducer } from "redux";

export interface IIPDListState {
  ipdDetailsByPID: ProjectIPDForm[];
}

export interface ProjectIPDForm {
  projectId: number;
  projectName: string;
  refDrugBrand: string;
  refDrugBrandOwner: string;
  ipdremarks: string;
  status: string;
  raremarks: string;
  projectDetailsByBusinessUnits: projectDetails[];
}

export interface projectDetails {
  detailId: number;
  projectId: number;
  ipevaluation: string;
  intellectualProperty: {
    ipdid: number;
    detailId: number;
    patentNumber: string;
    basicPatentExpiry: string;
    otherLimitingPatentDate: string;
    patenetStrategy: string;
    earliestLaunchDatePossible: string;
    litigationCostEstimate: number;
  };
  regulatory: {
    regulatoryId: number;
    detailId: number;
    typeOfSubmission: string;
    dossierFileQuality: string;
    estimatedFilingDate: string;
    estimatedApprovalDate: string;
  };
}

const initialState = {
  ipdDetailsByPID: [],
};

export const ipdReducer: Reducer<IIPDListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.IPD_DETAIL_BY_PID:
      return {
        ...state,
        ipdDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
